import { BehaviorSubject } from "rxjs";

const windowWidth = window?.innerWidth;
const defaultOpenMenu = windowWidth ? (windowWidth > 768) : true;

export const isLoading$ = new BehaviorSubject<boolean>(false);
export const manualLoading$ = new BehaviorSubject<boolean>(false);
export const propostasLoading$ = new BehaviorSubject<boolean>(false);
export const openMenu$ = new BehaviorSubject<boolean>(defaultOpenMenu);
export const tokenExpirado$ = new BehaviorSubject<boolean>(false);
export const modelCodigoServicoOpen$ = new BehaviorSubject<boolean>(false);
export const pageTitle$ = new BehaviorSubject<string>("");
export const standAlonePage$ = new BehaviorSubject<boolean>(false);
export const uploadUrl$ = new BehaviorSubject<string>("");
export const menuActived$ = new BehaviorSubject<number>(-1);
export const noPropagateDialog$ = new BehaviorSubject<boolean>(false);